import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["collapsed", "onHovered", "onExpandCollapse"];
import unescapedText from 'I18n/utils/unescapedText';
import { LeftIcon, RightIcon } from 'foundations-assets';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { useEffect } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
import { jsx as _jsx } from "react/jsx-runtime";
export const ExpandCollapseIcon = _ref => {
  let {
      collapsed,
      onHovered = emptyFunction,
      onExpandCollapse
    } = _ref,
    spaceProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  useEffect(() => {
    // when the component unmounts, make sure to set the hovered state to false
    return () => {
      onHovered(false);
    };
  }, [onHovered]);
  return /*#__PURE__*/_jsx(IconButton, Object.assign({}, spaceProps, {
    "aria-pressed": collapsed,
    tooltip: collapsed ? unescapedText('customer-data-board.columnExpand') : unescapedText('customer-data-board.columnCollapse'),
    use: "transparent",
    size: "extra-small",
    onClick: onExpandCollapse,
    onMouseEnter: () => {
      onHovered(true);
    },
    onMouseLeave: () => {
      onHovered(false);
    },
    "data-test-id": collapsed ? 'cdb-column-expand-button' : 'cdb-column-collapse-button',
    children: collapsed ? /*#__PURE__*/_jsx(RightIcon, {}) : /*#__PURE__*/_jsx(LeftIcon, {})
  }));
};